import { DatePicker } from 'antd5';
import React, { useEffect, useCallback, useRef } from 'react';
import { Box, useMultiStyleConfig } from '@chakra-ui/react';
import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';

dayjs.extend(weekday);
dayjs.extend(localeData);

const { RangePicker } = DatePicker;

export const DateRangePicker = ({ options = {}, value = [] }) => {
  const daterangepickerRef = useRef();

  const { size, variant, colorScheme } = options;
  const styles = useMultiStyleConfig('ReactDates', { size, variant, colorScheme });

  const blurOnResize = useCallback(() => {
    [...(daterangepickerRef?.current?.container?.querySelectorAll('input') || [])].forEach((el) => el?.blur());
  }, []);

  useEffect(() => {
    window.addEventListener('resize', blurOnResize);
    return () => window.removeEventListener('resize', blurOnResize);
  }, []);

  return (
    <Box __css={styles}>
      <RangePicker
        format="DD/MM/YYYY"
        value={value}
        onChange={(dates) => {
          if (options.onChange) {
            options.onChange(dates ?? null);
          }
        }}
      />
    </Box>
  );
};
